import { ORDER_PAYMENT_SUCCESS_SHOW_RECIEPT, ORDER_PAYMENT_FETCHING } from "./orderconfirmConstantTypes"
import axios from "axios";
import { snowmindsConfig } from "../../../configuration";

export const OrderConfirmAction = (orderConfirmWithData) => {
    return {
        type: ORDER_PAYMENT_SUCCESS_SHOW_RECIEPT,
        payload: orderConfirmWithData
    }
}
export const OrderFetching = () => {
    return {
        type: ORDER_PAYMENT_FETCHING,
        payload: { loading: false, error: '' }
    }
}
export const OrderError = (error) => {
    return {
        type: ORDER_PAYMENT_FETCHING,
        payload: { loading: false, error: error }
    }
}

export const GetOrder = (orderId) => {
    let snowminds = snowmindsConfig.getSnowMindsConfiguration();
    const url = snowminds.getbookingdetails;// `http://snowmindstest.s.cmshelp.dk/checkout/bookingdetails`;//`${snowminds.getbookingdetails}`;
    const currentBrandId = document.getElementById("hdBrand").value;
    const currentLanguage = document.getElementById("hdLanguage").value;
    const currentPageId = document.getElementById("hdPageId").value;
    const param = { 
        orderid: orderId,
        brandId:currentBrandId,
        pageId:currentPageId,
        language:currentLanguage
     };

    return (dispatch) => {
        dispatch(OrderFetching)
        axios.get(url, { params: param }, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(res => {
            //(`orderconfirmed- ${JSON.stringify(res.data)}`)
            dispatch(OrderConfirmAction(res.data));
            //(res)
        }).catch(err => { 
            //(err);
             dispatch(OrderError)
            });
    }

}